"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ChatReadSmallOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ChatReadSmallOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.894 1.808a.5.5 0 0 0-.788-.616l-2.78 3.558-1.475-1.452a.5.5 0 1 0-.702.712l1.875 1.846a.5.5 0 0 0 .745-.048l3.125-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15 3h-4.7C2.65 3 2 3.65 2 4.45v5.201c0 .8.65 1.45 1.45 1.45.635 0 1.15.515 1.15 1.15v1.392l1.633-1.634a3.101 3.101 0 0 1 2.192-.908h4.125c.8 0 1.45-.65 1.45-1.45V4.576l.82-1.05c.116.286.18.597.18.924v5.201a2.45 2.45 0 0 1-2.45 2.45H8.425a2.1 2.1 0 0 0-1.485.616l-2.486 2.487a.5.5 0 0 1-.854-.354v-2.599a.15.15 0 0 0-.15-.15A2.45 2.45 0 0 1 1 9.651V4.45A2.45 2.45 0 0 1 3.45 2H9l-.85 1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ChatReadSmallOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ChatReadSmallOutline;
exports["default"] = _default;